module.exports = {
  pagination: {
    of: 'of',
    page: 'Page',
    previousPage: 'Previous page',
    nextPage: 'Next page',
  },
  select: {
    placeholder: 'Select...',
  },
  table: {
    add: 'Add',
    noTableData: 'No data was found.',
    subtotal: 'Subtotal:',
  },
};



// WEBPACK FOOTER //
// ./js/lang/en/components.js